/*
 * Eluxa cart gift boxes.
 *
 * The free gifts are not cart lines (Razorpay Magic Checkout rejects 0-price lines); the qualifying line carries a
 * "Free gifts" line-item property instead. This script shows that visually: under every such line in the cart
 * drawer and on the cart page it inserts one gift-box card per gift (ribbon + bow, "Free Gift", 0 price with the
 * original price struck through). The cards are display-only - no quantity box, no delete - and exist only while
 * their line is in the cart, because they are re-derived from the line each time the cart renders.
 * Which gifts are shown is picked by the property text (each offer has its own note: cases get 4 gifts, the hub 2).
 * Gift data (title, image, original price) comes from the hidden #eluxa-free-gifts element.
 */
(function () {
  'use strict';

  var el = document.getElementById('eluxa-free-gifts');
  if (!el) return;
  var config;
  try { config = JSON.parse(el.getAttribute('data-config')); } catch (e) { return; }
  var offers = config.offers && config.offers.length ? config.offers : [{ note: config.note, display: config.display || [] }];
  var label = (config.noteLabel || 'Free gifts').trim().toLowerCase();
  if (config.mode === 'lines') return;

  var BOW = '<svg class="elx-cartgift__bow" viewBox="0 0 42 34" aria-hidden="true">' +
    '<path d="M21 17C14 6 4 3 3 9c-1 6 8 9 18 8z" fill="#ff8a4d" stroke="#d9531a" stroke-width="1.2" stroke-linejoin="round"/>' +
    '<path d="M21 17c7-11 17-14 18-8 1 6-8 9-18 8z" fill="#ff8a4d" stroke="#d9531a" stroke-width="1.2" stroke-linejoin="round"/>' +
    '<path d="M21 18l-8 14 8-5 8 5z" fill="#ff6a2b" stroke="#d9531a" stroke-width="1.2" stroke-linejoin="round"/>' +
    '<circle cx="21" cy="17" r="4.2" fill="#ff6a2b" stroke="#d9531a" stroke-width="1.2"/></svg>';
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8"/>' +
    '<path d="M7.5 8a2.5 2.5 0 0 1 0-5C11 3 12 8 12 8s1-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function norm(s) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().toLowerCase(); }

  function giftCard(g, qty) {
    return '<div class="elx-cartgift">' +
      (g.image ? '<img class="elx-cartgift__img" src="' + esc(g.image) + '" alt="" width="58" height="58" loading="lazy">' : '<span class="elx-cartgift__img"></span>') +
      '<div class="elx-cartgift__body"><p class="elx-cartgift__title">' + esc(g.title) + (qty > 1 ? ' &times; ' + qty : '') + '</p>' +
      '<span class="elx-cartgift__pill">' + ICON + 'Free Gift</span></div>' +
      '<div class="elx-cartgift__price"><span class="elx-cartgift__now">&#8377;0</span>' +
      (g.compare ? '<span class="elx-cartgift__was">&#8377;' + esc(g.compare) + '</span>' : '') + '</div>' +
      BOW + '</div>';
  }

  function giftProp(row) {
    var dts = row.querySelectorAll('dt');
    for (var i = 0; i < dts.length; i++) {
      if (dts[i].textContent.replace(/:\s*$/, '').trim().toLowerCase() === label) return dts[i].parentNode;
    }
    return null;
  }

  // The gifts for a line, matched on its property text; falls back to the first offer.
  function giftsFor(prop) {
    var dd = prop.querySelector('dd');
    var text = norm(dd ? dd.textContent : '');
    for (var i = 0; i < offers.length; i++) {
      if (offers[i].note && norm(offers[i].note) === text) return offers[i].display || [];
    }
    return offers[0].display || [];
  }

  function apply() {
    var rows = document.querySelectorAll('tr.cart-item');
    Array.prototype.forEach.call(rows, function (row) {
      var prop = giftProp(row);
      if (!prop) return;
      var gifts = giftsFor(prop);
      if (!gifts.length) return;
      prop.classList.add('elx-cartgift-prop-hidden');
      var next = row.nextElementSibling;
      if (next && next.classList.contains('elx-cartgift-row')) return;
      var qtyInput = row.querySelector('.quantity__input');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var cols = row.children.length || 4;
      var tr = document.createElement('tr');
      tr.className = 'elx-cartgift-row';
      tr.innerHTML = '<td colspan="' + cols + '">' + gifts.map(function (g) { return giftCard(g, qty); }).join('<div style="height:8px"></div>') + '</td>';
      row.parentNode.insertBefore(tr, row.nextSibling);
    });
    // drop gift rows whose qualifying line is gone
    Array.prototype.forEach.call(document.querySelectorAll('tr.elx-cartgift-row'), function (tr) {
      var prev = tr.previousElementSibling;
      if (!prev || !prev.classList.contains('cart-item') || !giftProp(prev)) tr.remove();
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    Promise.resolve().then(function () { scheduled = false; apply(); });
  }

  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  apply();
})();
